module.exports = __webpack_public_path__ + "img/fig02.215f9003.jpg";